import axios from 'axios'

/**
 * Extract a user-friendly error message from various error types
 */
export function extractErrorMessage(error: unknown, fallback?: string): string {
  if (axios.isAxiosError(error)) {
    // Handle Axios errors
    if (error.response?.data?.detail) {
      return String(error.response.data.detail)
    }
    if (error.response?.data?.message) {
      return String(error.response.data.message)
    }
    if (error.message) {
      return error.message
    }
    return fallback || 'An unexpected network error occurred'
  }

  if (error instanceof Error) {
    return error.message
  }

  if (typeof error === 'string') {
    return error
  }

  return fallback || 'An unexpected error occurred'
}
